import { createRouter, createWebHistory } from 'vue-router';


import CRMRankingView from '@/views/CRMRankingView/CRMRankingView.vue';
import CRMWhatsappContactsView from '@/views/CRMWhatsappContactsView/CRMWhatsappContactsView.vue';
import CRMWhatsappConversationsView from '@/views/CRMWhatsappConversationsView/CRMWhatsappConversationsView.vue';
import currentCRMWhatsappInvoicePaymentView from '@/views/currentCRMWhatsappInvoicePaymentView/currentCRMWhatsappInvoicePaymentView.vue';






import LoginView from '@/views/LoginView.vue';
import PageNotFoundView from '@/views/PageNotFoundView/PageNotFoundView.vue';

import CRMWhatsappConversationFeedbackView from '@/views/CRMWhatsappConversationFeedbackView/CRMWhatsappConversationFeedbackView.vue';


import CRMAgentsView from '@/views/CRMAgentsView/CRMAgentsView.vue';
import CRMAgentView from '@/views/CRMAgentView/CRMAgentView.vue';


import CRMWhatsappMediaCatalogsView from '@/views/CRMWhatsappMediaCatalogsView/CRMWhatsappMediaCatalogsView.vue';
import CRMWhatsappMarketingCampaignsView from '@/views/CRMWhatsappMarketingCampaingsView/CRMWhatsappMarketingCampaingsView.vue';
import TopNavigationBarView from '../views/TopNavigationBarView.vue';
import ChatView from '@/views/ChatView.vue';
import CRMLocalitiesView from '@/views/CRMLocalitiesView.vue';
import CRMDashboardView from '@/views/CRMDashboardView/CRMDashboardView.vue';
import currentCRMWhatsappInvoicesView from '@/views/currentCRMWhatsappInvoicesView.vue';
import CRMWhatsappContactFollowupsView from '@/views/CRMWhatsappContactFollowupsView.vue';
import CRMWhatsappProductFollowupsView from '@/views/CRMWhatsappProductFollowupsView/CRMWhatsappProductFollowupsView.vue';
import CRMWhatsappProductFollowupSummaryView from '@/views/CRMWhatsappProductFollowupSummaryView/CRMWhatsappProductFollowupSummaryView.vue';
import CRMProductSaleView from '@/views/CRMProductSale/CRMProductSaleView.vue';


import CRMWhatsappInvoicesView from '@/views/CRMWhatsappInvoicesView/CRMWhatsappInvoicesView.vue';
import CRMShippingRankingView from '@/views/CRMShippingRankingView.vue';

import insertCRMWhatsappContactFollowupView from '@/views/insertCRMWhatsappContactFollowupView/insertCRMWhatsappContactFollowupView.vue';

const routes = 
[
  {
    path: '/login',
    name: 'LoginView',
    component: LoginView
  },

  {
    path: '/CRMWhatsappConversationFeedback/:CRMWhatsappConversationFeedbackCRMWhatsappConversationID',
    name: 'CRMWhatsappConversationFeedbackView',
    component: CRMWhatsappConversationFeedbackView
  },

  {
    path: '/',
    name: 'TopNavigationBarView',
    component: TopNavigationBarView,
    children: 
    [
      {path: '/', redirect: '/login'},

      {path: '/CRMRanking', component: CRMRankingView},
      {path: '/CRMWhatsappContacts', component: CRMWhatsappContactsView},
      {path: '/CRMWhatsappConversations', component: CRMWhatsappConversationsView},
      {path: '/currentCRMWhatsappInvoicePayment', component: currentCRMWhatsappInvoicePaymentView},




      {path: '/CRMAgents', component: CRMAgentsView},
      {path: '/CRMDashboard/:CRMDashboardTab?', component: CRMDashboardView},
      {path: '/CRMWhatsappMarketingCampaigns/:CRMWhatsappMarketingCampaignID?', component: CRMWhatsappMarketingCampaignsView},

      {path: '/CRMAgent/:CRMAgentID/:CRMAgentTab?', component: CRMAgentView},


      {path: '/chat', component: ChatView},
      {path: '/CRMWhatsappMediaCatalogs', component: CRMWhatsappMediaCatalogsView},
      {path: '/CRMLocalities', component: CRMLocalitiesView},
      {path: '/currentCRMWhatsappInvoices', component: currentCRMWhatsappInvoicesView},
      {path: '/CRMWhatsappContactFollowups', component: CRMWhatsappContactFollowupsView},
      {path: '/CRMWhatsappProductFollowups', component: CRMWhatsappProductFollowupsView},
      {path: '/CRMWhatsappProductFollowupSummary', component: CRMWhatsappProductFollowupSummaryView},
      {path: '/CRMProductSale', component: CRMProductSaleView},
      {path: '/CRMShippingRanking', component: CRMShippingRankingView},

      {path: '/CRMWhatsappInvoices', component: CRMWhatsappInvoicesView},

      {path: '/insertCRMWhatsappContactFollowup', component: insertCRMWhatsappContactFollowupView},
    ]
  },
  
  {
    path: '/:pathMatch(.*)*',
    name: 'PageNotFoundView',
    component: PageNotFoundView
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
